var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.75 3.5H12.25C7.41751 3.5 3.5 7.41751 3.5 12.25V29.75C3.5 34.5825 7.41751 38.5 12.25 38.5H29.75C34.5825 38.5 38.5 34.5825 38.5 29.75V12.25C38.5 7.41751 34.5825 3.5 29.75 3.5Z",
    stroke: "#E1C17B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0005 19.8971C28.2164 21.3535 27.9677 22.8409 27.2895 24.1478C26.6114 25.4547 25.5385 26.5145 24.2233 27.1765C22.9081 27.8384 21.4177 28.0688 19.9641 27.8349C18.5104 27.601 17.1675 26.9147 16.1264 25.8736C15.0853 24.8325 14.399 23.4896 14.1651 22.0359C13.9312 20.5823 14.1616 19.0919 14.8235 17.7767C15.4855 16.4615 16.5453 15.3886 17.8522 14.7105C19.1591 14.0323 20.6465 13.7836 22.103 13.9996C23.5886 14.2198 24.964 14.9121 26.0259 15.9741C27.0879 17.0361 27.7802 18.4114 28.0005 19.8971Z",
    stroke: "#E1C17B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.625 11.375H30.6425",
    stroke: "#E1C17B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.ccd164e28fffc91784646828727223ae.svg";
export { ForwardRef as ReactComponent };